import React from "react";
import "./policy_terms.css";

const TermsConditions = () => {
  return (
    <div className="pt-container">
      <img src="/blur.jpg" alt="Bus" className="blur-image" />
      <div className="pt-content">
        <h1 className="pt-heading">EVIDE BUS TERMS & CONDITIONS</h1>

        <section className="pt-section">
          <p>
         Welcome to EVIDE BUS. By accessing or using this web application, you agree to comply with these Terms & Conditions. If you do not agree, please do not use the service.  </p>
        </section>

        <section className="pt-section">
          <h2 className="pt-subheading">Service Description</h2>
          <p>EVIDE BUS provides publicly available bus information, including:</p>
          <ul>
            <li>Bus names and numbers</li>
            <li>Available days</li>
            <li>Bus stops and timings</li>
             <li>Detailed bus timetables</li>
          </ul>
          <p>The service is informational only. EVIDE BUS does not provide bookings, ticketing, or payment services.</p>
        </section>

        <section className="pt-section">
          <h2 className="pt-subheading">Accuracy of Information</h2>
          <ul>
            <li>Bus schedules and details are collected from publicly available sources.</li>
            <li>The platform provides up-to-date information to the best of its ability, reflecting the latest schedules and timings.</li>
            <li>Users are encouraged to cross-check bus details before planning their travel.</li>
          </ul>
        </section>

        <section className="pt-section">
          <h2 className="pt-subheading">User Responsibilities</h2>
           <ul>
            <li>Access EVIDE BUS for informational purposes only.</li>
            <li>Cross-check bus schedules and timings before making travel plans.</li>
            <li>Refrain from interfering with the website’s functionality or attempting unauthorized actions.</li>
          </ul>

          
        </section>

        <section className="pt-section">
          <h2 className="pt-subheading">Limitation of Liability</h2>
          <ul>
            <li>EVIDE BUS is provided solely as a reference tool and is intended for general informational purposes.</li>
            <li>The platform is not responsible for any inaccuracies, omissions, or changes in bus schedules or related information.</li>
            
          </ul>
        </section>

        <section className="pt-section">
          <h2 className="pt-subheading">Intellectual Property</h2>
          <ul>
            <li>All text, design, layout, and code on EVIDE BUS are the property of the platform.</li>
            <li>Users are not permitted to copy, reproduce, distribute, or create derivative works without written consent.</li>
          </ul>
          
        </section>

        <section className="pt-section">
          <h2 className="pt-subheading">Changes to Terms & Conditions</h2>
          <ul>
            <li>EVIDE BUS may update these Terms & Conditions at any time.</li>
            <li>All updates will be posted on the website. Continued use of the platform signifies acceptance of the revised terms.</li>
           </ul>
        </section>

        <section className="pt-section">
          <h2 className="pt-subheading">Governing Law</h2>
        <ul>
            <li>These Terms & Conditions are governed by the laws of India.</li>
            <li>Any disputes arising from these terms will fall under the jurisdiction of the courts of India.</li>
           </ul>
         
        </section>

        <p className="pt-section">Thank you for using EVIDE BUS. We hope the platform helps you access accurate and useful bus information efficiently.</p>
      </div>
    </div>
  );
};

export default TermsConditions;

